module.exports = __webpack_public_path__ + "media/images/flip-836dd2b8b02743c20dc48bc61cea5fdc.svg";